import SampleAudioComponent from '@components/history/historyItem/body/tasks/values/sampleAudioComponent';
import SampleImageRecognitionComponent from '@components/history/historyItem/body/tasks/values/SampleImageRecognitionComponent';
import SampleCalculatorComponent from '@components/history/historyItem/body/tasks/values/SampleCalculatorComponent';
import SampleGpsComponent from '@components/history/historyItem/body/tasks/values/sampleGpsComponent';
import SampleImageComponent from '@components/history/historyItem/body/tasks/values/sampleImageComponent';
import SampleMultiTextComponent from '@components/history/historyItem/body/tasks/values/sampleMultiTextComponent';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, Row } from 'antd';
import * as React from 'react';

import SampleTextComponent from './history/historyItem/body/tasks/values/SampleTextComponent';

interface IProp {
  sections: any,
  process: any
}
interface IState {
  formattedComponents: IItemHistory[]
}

interface IItemHistory {
  title: string,
  description: any,
  identifier: string, // identifier that is displayied by the title side
  type?: any,
  labels?: any
}

class TableHistoryComponent extends React.Component<IProp, IState> {

  state = {
    formattedComponents: []
  };

  private alreadyCheckedSections: any[] = [];
  private nestedContentIndexes: any[] = [];

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    if (this.props.sections)
      this.formatComponentsData(this.props.sections)
  }
  clearState() {
    this.alreadyCheckedSections = [];
    this.nestedContentIndexes = [];
  }
  componentWillUpdate(props: any) {
    if (props.sections != this.props.sections) {
      this.clearState();
      this.formatComponentsData(props.sections)
    }
  }

  formatComponentsData(sections: any) {
    let itensList: IItemHistory[] = [];
    this.alreadyCheckedSections = [];

    this.nestedContentIndexes.push(1);

    sections.forEach((section: any) => {
      if (this.CheckSectionAlreadyChecked(section, this.alreadyCheckedSections) == false) {
        let valuesToConcat = this.GetSectionComponents(section, sections);
        itensList = itensList.concat(valuesToConcat);
      }
    });
    if (itensList && itensList.length > 0) {
      this.setState({ formattedComponents: itensList });
    }
  }

  GetSectionComponents(section: any, allSections: any[]): IItemHistory[] {
    this.alreadyCheckedSections = this.alreadyCheckedSections.concat(section);
    let already = this.alreadyCheckedSections.find(v => v.id === section.next)
    let itensList: IItemHistory[] = [];
    section.components.forEach((comp: any) => {
      if (comp.type == ComponentType.GOTO) {
        let gotoIndex = 0;

        for (let nextSectionId of comp.nexts) {
          if (nextSectionId) {
            let nextSection = allSections.find(s => s.id == nextSectionId);
            let itemHistory = this.GetHistoryItemInfo(comp, gotoIndex);
            itensList.push(itemHistory);
            if (nextSection) {
              this.nestedContentIndexes.push(1);
              const innerContent = this.GetSectionComponents(nextSection, allSections)
              this.nestedContentIndexes.splice(this.nestedContentIndexes.length - 1, 1);
              for (let gotoitems of innerContent) {
                if(itensList.find(i => i.title == gotoitems.title) === undefined)
                itensList.push(gotoitems);
              }
            }
            this.increaseIdentifierValue();
            gotoIndex++;
          }
        }
      }

      if (comp.type == ComponentType.SAMPLE) {
        let gotoIndex = 0;

        let res: any = [[]];
        let group = 0;
        const max = comp.nexts.length / comp.value.length

        for (let i = 0; i < comp.nexts.length; i++) {
          if (res[group] === undefined) {
            res[group] = [];
          }
          res[group].push(comp.nexts[i]);
          if ((i + 1) % max === 0) {
            group = group + 1;
          }
        }

        let itemHistory: IItemHistory = this.GetHistoryItemInfo(comp);
        if (itemHistory.description !== undefined && itemHistory.description !== '') {
          itensList.push(itemHistory);
        }
        for (let [idxValue, value] of comp.value.entries()) {
          this.nestedContentIndexes.push(idxValue + 1);

          let itemHistory = this.GetHistoryItemInfo(value, gotoIndex);
          itensList.push(itemHistory);
          if (res[idxValue]) {
            for (let [idxNext, nextSectionId] of res[idxValue].entries()) {
              if (nextSectionId) {
                let nextSection = allSections.find(s => s.id == nextSectionId);
                if (nextSection) {
                  this.nestedContentIndexes.push(idxNext + 1);
                  const innerContent = this.GetSectionComponents(nextSection, allSections)
                  this.nestedContentIndexes.splice(this.nestedContentIndexes.length - 1, 1);
                  for (let gotoitems of innerContent) {
                    itensList.push(gotoitems);
                  }
                }
              }
            }
          }
          this.nestedContentIndexes.splice(this.nestedContentIndexes.length - 1, 1);
          gotoIndex++;
        }
        this.increaseIdentifierValue();
      }

      else {
        let itemHistory: IItemHistory = this.GetHistoryItemInfo(comp);
        if (itemHistory.description !== undefined && itemHistory.description !== '' && itemHistory.description.props && itemHistory.description.props.text !== '') {
          itensList.push(itemHistory);
          this.increaseIdentifierValue();
        }
      }

    });
    if (section.next && already === undefined) {
      let nextSection = allSections.find(s => s.id == section.next);
      if (nextSection) {
        itensList = itensList.concat(this.GetSectionComponents(nextSection, allSections));
      }
    }
    return itensList;
  }

  GetHistoryItemInfo(component: any, descriptionIndex?: number): IItemHistory {
    let itemData: IItemHistory = {
      title: '',
      description: '',
      identifier: ''
    };

    if (component) {
      itemData.title = component.title ? component.title : component;
      itemData.description = this.getComponentValue(component.type, component, descriptionIndex) || '';
      itemData.identifier = this.getIdentifier();
      itemData.type = component.type || null
      itemData.labels = component.labels || null
    }
    return itemData;
  }

  increaseIdentifierValue() {
    this.nestedContentIndexes[this.nestedContentIndexes.length - 1] = this.nestedContentIndexes[this.nestedContentIndexes.length - 1] + 1;
  }

  getIdentifier() {
    let id = '';
    this.nestedContentIndexes.forEach((element, i: number) => {
      if (i > 0) {
        id += '.';
      }
      id += element;
    });

    return id;
  }


  CheckSectionAlreadyChecked(section: any, alreadyCheckedSections: any[]) {
    if (alreadyCheckedSections.find(s => s.id == section.id) != null)
      return true;
    return false;
  }

  renderComponentItem(component: IItemHistory, i: number) {
    return (
      <GoEpikTaskHolder key={i} >
        {component.type && component.type !== 25 && <Row className={i % 2 === 0 ? 'table-row-white' : "table-row-gray"} >
          <Col style={{ paddingRight: '4rem' }} sm={12} md={12} xl={12} >
            <span className="goepik-history-question-text"> {component.identifier} - </span>
            <span style={{ fontWeight: 'bold' }}> {component.title}</span>

          </Col>
          <Col className="goepik-history-question-text" sm={12} md={12} xl={12}>
            <span> {component.description}</span>
          </Col>
        </Row>}
        {component.type && component.type === 25 && (<>
          <Row className={i % 2 === 0 ? 'table-row-white' : "table-row-gray"} >
            <Col style={{ paddingRight: '4rem' }} sm={24} md={24} xl={24} >
              <span className="goepik-history-question-text"> {component.identifier} - </span>
              <span style={{ fontWeight: 'bold' }}> {component.title}</span>

            </Col>
          </Row>
          <Row>
            <Col className="goepik-history-question-text" sm={24} md={24} xl={24}>
              <span>{component.description}</span>
            </Col>
          </Row>
        </>)}
      </GoEpikTaskHolder>
    )
  }


  renderContent() {
    const { formattedComponents } = this.state;
    return (
      this.renderItems(formattedComponents)
    )
  }

  renderItems(componentItems: IItemHistory[]) {
    return (
      componentItems.map((component: any, i: number) => {
        return (
          <Row key={i}>
            {this.renderComponentItem(component, i)}
            {
              (component.innerContent != undefined && component.innerContent.length > 0) &&
              <Row className={"nested-content"}>
                <Col sm={24} md={24} xl={24} >
                  {this.renderItems(component.innerContent)}
                </Col>
              </Row>
            }
          </Row >
        )
      })
    )
  }

  getComponentValue(type: ComponentType, component: any, descriptionIndex?: number): any {

    if (component.value) {
      try {
        if (component.type === ComponentType.TEXT) {
          if (Array.isArray(component.value))
            component.value = component.value[0];
        } else {
          component.value = JSON.parse(component.value);
        }
      }
      catch (e) {
      }
    }

    if (component.value === undefined) {
      return '';
    }
    if (component.value === []) {
      return '';
    }
    if (component.value.length === 0) {
      return '';
    }
    switch (type) {
      case ComponentType.PROBLEM:
        return (
          <SampleTextComponent text={component.value} />
        )
      case ComponentType.GPS:
        const coordinates = component.value.join(',')
        return (
          <SampleGpsComponent coordinates={coordinates} />
        )
      case ComponentType.DATE:
        const values: any[] = [];
        try {
          if (component.value) {
            component.value.map((item: any) => {
              let d = new Date(item);
              let utcDate = d.getUTCDate();
              d.setDate(utcDate);

              values.push(`${(new Date(d).toLocaleDateString()).toString()} - ${(new Date(d).toLocaleTimeString('pt-BR')).toString()}`)
            })
          }
          return (
            <SampleMultiTextComponent texts={values} />
          )
        }
        catch (e) {
          try {
            let d = new Date(component.value);
            let utcDate = d.getUTCDate();
            d.setDate(utcDate);
            return (
              <SampleTextComponent text={`${(new Date(d).toLocaleDateString().toString())} - ${(new Date(d).toLocaleTimeString('pt-BR').toString())}`} />
            )
          }
          catch (e) {
            return;
          }
        }

      case ComponentType.DRAW:
        return (
          <SampleImageComponent actionText={(I18n.l('common.visualize')) + " " + (I18n.l('common.draw'))} url={component.value} />
        )

      case ComponentType.PHOTO:
        let imgComponent = [];
        for (let [index, img] of component.value.entries()) {
          imgComponent.push(<SampleImageComponent key={index} actionText={`${(I18n.l('common.visualize'))} ${(I18n.l('common.image'))} ${index + 1}`} url={img} />)
        }
        return (
          imgComponent
        )

      case ComponentType.SELECT:
        if (component.value.length > 0) {
          return (<SampleMultiTextComponent texts={component.value} />);
        }
        return (
          <SampleTextComponent text={component.value} />
        )

      case ComponentType.CONFIRM:
        if (component.result) {
          return (
            <SampleTextComponent text={component.result} />
          )
        }
        if (component.value !== undefined) {
          return (
            <SampleTextComponent text={I18n.l('common.yes')} />
          )
        } else {
          return (
            <SampleTextComponent text={I18n.l('common.no')} />
          )
        }

      case ComponentType.NUMBER:
        return (
          <SampleTextComponent text={component.value.toString()} />
        )

      case ComponentType.SCORE:
        if (component.value === null || component.value === undefined) {
          <p>{I18n.l('history.timeline.cantShowContent.label')}</p>
        } else {

          return (
            <GoEpikScore>
              {component && component.resultValue
                ?
                component.resultValue.toString()
                :
                <div>
                  <span>
                    {I18n.l('labels.scoreLabel')}
                  </span>
                  <span>{component.value.toString()}</span>
                </div>
              }
            </GoEpikScore>
          )
        }

      case ComponentType.TEXT:
        if (Array.isArray(component.value) && component.value.length > 0) {
          return (<SampleMultiTextComponent texts={component.value} />);
        }
        return (
          <SampleTextComponent text={component.value} />
        )

      case ComponentType.MATRIX:

        const content: string[] = [];
        if (component.value.labelX && component.value.valueX) content.push((component.value.labelX + ": " + component.value.valueX));
        if (component.value.labelY && component.value.valueY) content.push((component.value.labelY + ": " + component.value.valueY));
        if (component.value.result) content.push((component.value.result));

        return (
          <SampleMultiTextComponent texts={content} />
        )

      case ComponentType.GOTO:
        let description = "";
        if (component.value) {
          try {
            if (descriptionIndex !== undefined) {
              description = component.value[descriptionIndex];
            }
          }
          catch (e) {
            description = component.value.toString();
          }
        }
        return (
          <SampleTextComponent text={description} />
        )
      case ComponentType.SAMPLETEXT:

        return (
          <SampleTextComponent text={component.value.toString()} />
        )
      case ComponentType.SAMPLEIMAGE:
        return (
          <SampleImageComponent actionText={(I18n.l('common.visualize')) + " " + (I18n.l('common.image'))} url={component.value} />
        )

      // TODO verificar qual o tipo de dado que deve ser apresentado nesse select
      case ComponentType.SELECTAPI:
        return (
          <SampleMultiTextComponent texts={component.value} />
        )

      case ComponentType.TREEVIEW:
        return (
          <SampleMultiTextComponent texts={component.value} />
        )
      case ComponentType.SAMPLE:
        return (
          <SampleTextComponent text='' />
        )

      case ComponentType.AUDIO:
        return (
          <SampleAudioComponent url={component.value} />
        )

      case ComponentType.IMAGERECOGNITION:
        return (
          <SampleImageRecognitionComponent component={component} process={this.props.process} />
        )

      case ComponentType.CALCULATOR:
        return (
          <SampleCalculatorComponent component={component} />
        )

      default:
        return (
          <SampleTextComponent text={I18n.l('history.timeline.cantShowContent.label')} />
        )
    }
  }

  render(): JSX.Element {
    return (
      <Row>
        <Col sm={24} md={24} xl={24}>
          {
            this.renderContent()
          }
        </Col>
      </Row>
    );
  }
};

const GoEpikTaskHolder = styled.div`

.table-row-white{
  background-color:#fff;
}

.table-row-gray{
  background-color:#F4F6FF;
}
    margin-bottom: 12px;

    .goepik-history-question-text{
        font-weight:500;
    }
`;

const GoEpikScore = styled.div`
    color: ${Theme.standard.orange};
    font-weight: bold;
    font-size: x-large;    
    span {
        margin-right: 0.5em;
    }
`;



export default TableHistoryComponent;
